module.exports = __webpack_public_path__ + "img/32.1b5019a9.jpg";